import {
  AllPossibleInlineMetrics,
  MetricsKey,
} from "@/components/pages/common/resources-ag-grid/utils/metrics/metricsTypes";
import { metricsChartsPeriods } from "@/components/pages/common/resource-details/utils/constants/metrics";
import { MetricPeriods } from "@/components/pages/common/resource-details/utils/types/metrics";

export const getMetricsByFrequency = (
  metricKey: MetricsKey,
  metricsData: AllPossibleInlineMetrics,
  metricFrequencyValue?: MetricPeriods,
) => {
  if (!metricFrequencyValue) {
    return;
  }

  const frequency = metricsChartsPeriods[metricFrequencyValue]?.frequency as
    | "daily"
    | "hourly";

  const metrics = metricsData?.[metricKey];

  return metrics?.[frequency];
};
